export default class CropData {
    /**
     *
     * @param {object} [cropData = {}]
     * @param {number} cropData.x
     * @param {number} cropData.y
     * @param {number} cropData.width
     * @param {number} cropData.height
     * @param {number} cropData.imageWidth
     * @param {number} cropData.imageHeight
     */
    constructor(cropData = {}) {
        if (typeof cropData === 'object') {
            this.x = cropData.x || 0;
            this.y = cropData.y || 0;
            this.width = cropData.width || 0;
            this.height = cropData.height || 0;
            this.imageWidth = cropData.imageWidth || 0;
            this.imageHeight = cropData.imageHeight || 0;
        }
    }

    get x() {
        return this._x;
    }
    set x(value) {
        this._x = Math.round(value);
    }

    get y() {
        return this._y;
    }
    set y(value) {
        this._y = Math.round(value);
    }

    get width() {
        return this._width;
    }
    set width(value) {
        this._width = Math.round(value);
    }

    get height() {
        return this._height;
    }
    set height(value) {
        this._height = Math.round(value);
    }

    get imageWidth() {
        return this._imageWidth;
    }
    set imageWidth(value) {
        this._imageWidth = Math.round(value);
    }

    get imageHeight() {
        return this._imageHeight;
    }
    set imageHeight(value) {
        this._imageHeight = Math.round(value);
    }

    /**
     * whether current cropData defines original image
     * @return {boolean}
     */
    isMaxCropped() {
        const thresholdPx = 1,
            deltaWidth = Math.abs(this.width - this.imageWidth),
            deltaHeight = Math.abs(this.height - this.imageHeight);

        return this.x <= thresholdPx && this.y <= thresholdPx
            && deltaWidth <= thresholdPx
            && deltaHeight <= thresholdPx;
    }

    toObject() {
        const obj = {};

        obj.x = this.x;
        obj.y = this.y;
        obj.width = this.width;
        obj.height = this.height;
        obj.imageWidth = this.imageWidth;
        obj.imageHeight = this.imageHeight;

        return obj;
    }
}